module.exports = "<div class=\"Form-select\">\n  <select ng-model=\"selectValue\" ng-options=\"{{::optionsEpression}}\">\n    <option value=\"\" selected=\"selected\"></option>\n  </select>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/directives/select.html
// module id = 497
// module chunks = 24